import { css } from '@inter-ikea-kompis/web-component';
import { IconSizeCalculator } from '@inter-ikea-kompis/component-icon';
import { Text } from '@ingka/common-styles-webc';
import FunctionIconEnum from '../../enums/FunctionIconEnum.js';
const OUTLINE_SIZE = {
    xsmall: 32,
    small: 40,
    medium: 48
};
const ICON_SIZE = {
    small: 24,
    medium: 32
};
/**
 * IconButton Style.
 */
export default class FunctionIconStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @returns Styles.
     */
    static getStyle(options) {
        const { color } = options.theme;
        return css `
			${Text.CSS}
			:host {
				display: flex;
				align-items: center;
				position: relative;
			}
			.container {
				display: flex;
				justify-content: center;
				align-items: center;
				background: ${color.neutral.grey200};
				border-radius: 50%;
				width: ${this.getOutlineSize(options.size)};
				height: ${this.getOutlineSize(options.size)};
			}
			${this.getIconStyle(options)}
		`;
    }
    /**
     * Returns icon container size.
     *
     * @param size ...
     */
    static getOutlineSize(size) {
        if (size === FunctionIconEnum.xsmall) {
            return `${OUTLINE_SIZE.xsmall / 16}rem`;
        }
        else if (size === FunctionIconEnum.small) {
            return `${OUTLINE_SIZE.small / 16}rem`;
        }
        return `${OUTLINE_SIZE.medium / 16}rem`;
    }
    /**
     * Returns icon style.
     *
     * @param options ...
     */
    static getIconStyle(options) {
        const { size, icon } = options;
        if (!icon) {
            return '';
        }
        const { width, height } = size === FunctionIconEnum.small || size === FunctionIconEnum.xsmall
            ? IconSizeCalculator.getMeasuredSize(icon, ICON_SIZE.small)
            : IconSizeCalculator.getMeasuredSize(icon, ICON_SIZE.medium);
        return css `
			svg {
				width: ${IconSizeCalculator.round(width / 16)}rem;
				height: ${IconSizeCalculator.round(height / 16)}rem;
			}
		`;
    }
}
//# sourceMappingURL=FunctionIconStyle.js.map